<template>
  <List
    class="survey-list"
    titleI18nKey="admin.crm.survey.menu"
    no-head-btn
    no-pagination
    :loading="loading"
    :listData="listData"
    :tableColumns="tableColumns"
    @action="handleEdit"
  ></List>
</template>

<script>
import { mapActions } from 'vuex'
import List from '@/components/tableList/allowDragSortTable.vue'

export default {
  components: {
    List
  },
  data () {
    return {
      loading: false,
      listData: []
    }
  },
  computed: {
    tableColumns () {
      const columns = [
        {
          labelI18nKey: 'admin.crm.survey.label.name',
          dataKey: 'survey_type',
          formatter: (value) => {
            return this.$t(`admin.crm.survey.surveyType.${value}`)
          }
        }
      ]
      return columns
    }
  },
  async created () {
    this.loading = true
    try {
      const resp = await this.searchSurvey()
      if (resp) {
        this.listData = resp.survey
      }
    } finally {
      this.loading = false
    }
  },
  methods: {
    ...mapActions('survey', ['searchSurvey']),
    handleEdit (rowData) {
      this.$router.push(`/v-admin/crm-management/survey/edit/${rowData.id}`)
    }
  }
}
</script>

<style lang="scss" scoped>
.survey-list {
  .list-title {
    font-size: 18px;
  }

  ::v-deep.table-list-wrapper {
    .table-header {
      height: 0;
    }
  }
}
</style>
